import { useState } from "react";
import { Admin } from "@digital-girls-hub/shared-resources/models/db";
import usePromise from "./usePromise";
import { getCookieObject } from "../cookie";
import { services } from "../../services";
import { setAccessToken } from "../../services/request";
import { AdminRole, resolveAdminRole } from "../roles";

export type AuthState = { is_authenticated: boolean } & Partial<{
  access_token: string;
  admin: Pick<Admin, "id" | "stateId" | "email" | "name" | "type">;
  role: AdminRole;
}>;

export function useAuth() {
  const [authState, setAuthState] = useState<AuthState>({
    is_authenticated: false,
  });

  const { error } = usePromise(
    {
      fn: async () => {
        const { access_token: accessToken } = getCookieObject();
        const cookieValidationResponse = await services.requestSvc
          .get<{
            id: number;
            email: string;
            name: string;
            stateId: number;
            type: Admin["type"];
          }>("/validate-token", {
            withCredentials: true,
            // headers: { Authorization: "Bearer " + accessToken },
          })
          .catch(console.error);

        console.log("Cookie validation response", cookieValidationResponse);

        if (cookieValidationResponse) {
          setAuthState({
            is_authenticated: true,
            access_token: accessToken,
            admin: {
              id: BigInt(cookieValidationResponse.id),
              email: cookieValidationResponse.email,
              stateId: cookieValidationResponse.stateId
                ? BigInt(cookieValidationResponse.stateId)
                : undefined,
              name: cookieValidationResponse.name,
              type: cookieValidationResponse.type,
            },
            role: resolveAdminRole({
              type: cookieValidationResponse.type,
            }),
          });
          setAccessToken(accessToken);
        } else {
          setAuthState({
            is_authenticated: false,
            access_token: undefined,
            admin: undefined,
            role: undefined,
          });
          setAccessToken();
        }
      },
      runOnMount: { args: [] },
    },
    []
  );

  console.log(error);

  return authState;
}
